export function createSingleFlightQueue() {
  let chain = Promise.resolve()

  return async function run<T>(task: () => Promise<T>): Promise<T> {
    const next = chain.then(task, task)
    // maintenir la chaîne même si la tâche échoue
    chain = next.then(() => undefined, () => undefined)
    return next
  }
}
